import _ from "lodash";
import { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import PrescriptionsTable from "./table-list/index";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useApi } from "../../utils/hooks";
import TitleHeadSess from "../../utils/TitleHeadSess";
import PatientAutocomplete from "../utils/patient/search/Autocomplete";
import { useAuth } from "../../auth/context";

const queryKey = "medicalDocuments";

//TODO avoid repeating with medicalDocument/form/patient/index.jsx
const defaultPatient = { id: "", surname: "" };
const PatientPicker = ({ setPatient }) => {
  const form = useForm({ defaultValues: defaultPatient });
  const patientId = form.watch("id");

  useEffect(() => {
    const patient = form.getValues();
    setPatient(patient);
  }, [patientId]);

  return (
    <PatientAutocomplete
      form={form}
      helperText=""
      label={"Buscar"}
      noRequired={true}
    />
  );
};

const Prescriptions = () => {
  const api = useApi();
  const { user } = useAuth();
  const [patient, setPatient] = useState(defaultPatient);
  const [page, setPage] = useState(0);
  const [sortingField, setSortingField] = useState(null);
  const rowsPerPage = 10;
  const queryClient = useQueryClient();

  const paginationOptions = { page, limit: rowsPerPage };

  const handleRequestSort = (newSortField) => {
    // Only update state if sorting by date or id
    if (newSortField.id === "date" || newSortField.id === "id") {
      setSortingField(newSortField);
    } else {
      // For other columns, reset to null (client-side sorting)
      setSortingField(null);
    }
  };

  const getMedicalDocuments = async () => {
    const patientFilter = patient.id && user?.patientMedicalDocumentsFilters(patient);
    const filters = _.assign({}, patientFilter);
    const queryParams = { filters, ...paginationOptions };
    
    if (sortingField?.id === "date") {
      queryParams.sortBy = `date:${sortingField.direction.toUpperCase()}`;
    } else if (sortingField?.id === "id") {
      queryParams.sortBy = `id:${sortingField.direction.toUpperCase()}`;
    }
    
    return api.medicalDocuments(queryParams);
  };

  const {
    isLoading: loading,
    data: { data: medicalDocuments, meta: { totalItems } = {} } = {},
  } = useQuery({
    queryKey: [queryKey, patient.id, paginationOptions, sortingField],
    queryFn: () => getMedicalDocuments(),
    staleTime: 5 * 60 * 1000, // Data stays fresh for 5 minutes
  });

  useEffect(() => {
    return () => {
      queryClient.removeQueries(queryKey);
    };
  }, [queryClient]);


  return (
    <Stack
      spacing="1rem"
      sx={{ p: { xs: "1rem", sm: "2rem" }, mt: { xs: "1rem" }, width: "100%" }}
    >
      <TitleHeadSess title={"Prescripciones"} urlRedirect={"/"} />
      <Stack sx={{ width: "100%" }}>
        <PatientPicker setPatient={setPatient} />
      </Stack>
      <PrescriptionsTable
        medicalDocuments={medicalDocuments}
        loading={loading}
        page={page}
        rowsPerPage={rowsPerPage}
        setPage={setPage}
        count={totalItems}
        handleRequestSort={handleRequestSort}
      />
    </Stack>
  );
};

export default Prescriptions;
